<!--
 * @Description: 现金宝定期取出列表
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="bizcomp-money-in-list">
        <div>
            <div>
                <div class="money-in-text">
                    自动取出计划，让存在{{
                        $const.getXJBParam("sname")
                    }}的资金在您指定的日期自动取出到您指定的账号。特别适合还信用卡、付房租、还房贷！
                </div>
                <el-table :data="pageFund" style="width: 100%" class="tab-list-tit">
                    <div slot="empty" class="auto-in-null">
                        <img src="../../assets/img/auto-out-null.svg" alt="" class="margin-r-4" />
                        您还没有自动取出计划，马上设置一个吧！
                    </div>
                    <el-table-column
                        prop="bankcode"
                        label="资金去向"
                        align="center"
                        :formatter="formatterBankCode"
                        min-width="100"
                    />
                    <el-table-column
                        prop="sellvol"
                        label="取出金额"
                        align="center"
                        :formatter="formatterNum"
                    ></el-table-column>
                    <el-table-column
                        prop="investcycle"
                        label="取出周期"
                        align="center"
                        :formatter="formatterCycle"
                    ></el-table-column>
                    <el-table-column
                        prop="nextinvestdate"
                        label="下一取出日"
                        align="center"
                        :formatter="formatterDate"
                    ></el-table-column>
                    <el-table-column prop="status" label="状态" align="center">
                        <template slot-scope="scope">
                            <div>
                                <span
                                    :class="
                                        'fund-status ' +
                                        (scope.row.status == 'N'
                                            ? 'normal-color'
                                            : scope.row.status == 'P'
                                            ? 'stop-color'
                                            : 'termination-color')
                                    "
                                >
                                    {{ formatterStatus(scope.row.status) }}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="statusText" label="操作" align="center" width="280">
                        <template slot-scope="scope">
                            <div class="fund-desc-btns">
                                <div
                                    v-if="
                                        scope.row.statusText.indexOf('c') > -1 &&
                                        scope.row.statusText.indexOf('s') === -1
                                    "
                                    class="display-flex"
                                    v-on:click.prevent="btnAction('c', scope.row)"
                                >
                                    <div class="fund-desc-btn">修改</div>
                                    <div class="bar"></div>
                                </div>
                                <div
                                    v-if="scope.row.statusText.indexOf('s') > -1"
                                    class="display-flex"
                                    v-on:click.prevent="btnAction('s', scope.row)"
                                >
                                    <div class="fund-desc-btn">恢复</div>
                                    <div class="bar"></div>
                                </div>
                                <div
                                    v-if="scope.row.statusText.indexOf('p') > -1"
                                    class="display-flex"
                                    v-on:click.prevent="btnAction('p', scope.row)"
                                >
                                    <div class="fund-desc-btn">暂停</div>
                                    <div class="bar"></div>
                                </div>
                                <div
                                    v-if="scope.row.statusText.indexOf('e') > -1"
                                    class="display-flex"
                                    v-on:click.prevent="btnAction('e', scope.row)"
                                >
                                    <div class="fund-desc-btn">终止</div>
                                    <div class="bar"></div>
                                </div>
                                <div
                                    class="fund-desc-btn"
                                    v-on:click.prevent="showMoreInfo(scope.row)"
                                >
                                    更多
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                v-if="allPage - 0 >= Number(pageSize)"
                :current-page.sync="curPage"
                :page-size="Number(pageSize)"
                layout="total, prev, pager, next"
                :total="allPage"
                class="pagination-content"
                v-on:current-change="handleCurrentChange"
            ></el-pagination>
            <div class="add-plan-content">
                <div class="add-plan-btn" v-on:click="moneyOutShowFn">
                    <div class="add-icon">+</div>
                    <div class="color-E60012 add-text">新增自动取出</div>
                </div>
            </div>
        </div>
        <el-dialog
            title="交易详情"
            :visible.sync="tranInfoVisible"
            width="680px"
            class="prop tran-info-dialog"
            v-on:close="dialogClose"
        >
            <div class="info-dialog-header">
                <div class="position-absolute1">
                    <div class="header-img-contain">
                        <img v-if="opIndex == '1'" src="../../assets/img/op-select.svg" alt="" />
                        <img v-else src="../../assets/img/op-unselect.svg" alt="" />
                    </div>
                    <span :class="'header-img-text1 ' + (opIndex == '1' ? 'color-f006671' : '')">
                        1:选择操作
                    </span>
                </div>
                <div class="position-absolute2">
                    <div class="header-img-contain">
                        <img v-if="opIndex == '2'" src="../../assets/img/op-select.svg" alt="" />
                        <img v-else src="../../assets/img/op-unselect.svg" alt="" />
                    </div>
                    <span :class="'header-img-text2 ' + (opIndex == '2' ? 'color-f006671' : '')">
                        2:确认信息
                    </span>
                </div>
                <div class="position-absolute3">
                    <div class="header-img-contain">
                        <img v-if="opIndex == '3'" src="../../assets/img/op-select.svg" alt="" />
                        <img v-else src="../../assets/img/op-unselect.svg" alt="" />
                    </div>
                    <span :class="'header-img-text3 ' + (opIndex == '3' ? 'color-f006671' : '')">
                        3:完成设置
                    </span>
                </div>
            </div>
            <div v-if="opIndex == '2'" class="margin-t-50">
                <div>
                    <el-form label-width="180px" class="tran-info-form">
                        <el-form-item v-if="opType" label="业务类型：" class="form-text">
                            <div class="text-con">
                                {{ opType }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="detailInfo.fundname"
                            label="基金名称："
                            class="form-text"
                        >
                            <div class="text-con">
                                {{ detailInfo.fundname + "[" + detailInfo.fundcode + "]" }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="detailInfo.sharetype"
                            label="收费方式："
                            class="form-text"
                        >
                            <div class="text-con">
                                {{
                                    detailInfo.sharetype == "0"
                                        ? "前收费"
                                        : detailInfo.sharetype == "1"
                                        ? "后收费"
                                        : ""
                                }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="detailInfo.bankcode"
                            label="存入账号："
                            class="form-text"
                        >
                            <div class="text-con">
                                {{
                                    $cache.getDict("110079", detailInfo.channelid.substr(0, 4)) +
                                    "-" +
                                    $cache.getDict("110080", detailInfo.bankcode).substr(-4, 4) +
                                    "(" +
                                    detailInfo.depositcard.substr(-6, 6) +
                                    ")"
                                }}
                            </div>
                        </el-form-item>
                        <el-form-item
                            v-if="detailInfo.sellvol"
                            label="每期金额："
                            class="form-text"
                        >
                            <div class="text-con">
                                {{ $util.fmtNum(detailInfo.sellvol) + "元" }}
                            </div>
                        </el-form-item>
                        <el-form-item label="交易密码：" prop="pwd">
                            <el-input
                                v-model.trim="tradepwd"
                                type="password"
                                placeholder="请输入交易密码"
                                :maxlength="16"
                            />
                            <span
                                class="redemp-btn margin-l-10"
                                v-on:click.prevent="$router.push({ name: 'tradepwd' })"
                            >
                                <span class="like-a">忘记密码？</span>
                            </span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="btn-contain">
                    <button class="cancel-btn" v-on:click="dialogClose">取消</button>
                    <button
                        :class="'confirm-btn ' + (!tradepwd ? 'disable-btn' : 'active-btn')"
                        :disabled="!tradepwd"
                        v-on:click="nextFn"
                    >
                        {{ opType }}
                    </button>
                </div>
            </div>
            <div v-if="opIndex == '3'" class="margin-t-50">
                <div class="successs-img-text">
                    <img src="../../assets/img/buy_success.png" alt="" class="success-img" />
                    <div class="successs-text">
                        {{ "您好，" + opType + "操作设置成功！" }}
                    </div>
                </div>
                <div class="btn-contain">
                    <button class="confirm-btn active-btn" v-on:click="dialogClose">确定</button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="详情"
            :visible.sync="infoVisible"
            width="580px"
            class="prop tran-info-dialog"
            v-on:close="infoDialogClose"
        >
            <div>
                <el-form label-width="180px" class="tran-info-form padding-t-20">
                    <el-form-item v-if="detailInfo.operdate" label="设置时间：" class="form-text">
                        <div class="text-con">
                            {{ formatDate(detailInfo.operdate) }}
                        </div>
                    </el-form-item>
                    <el-form-item
                        v-if="detailInfo.investcycle"
                        label="取出周期："
                        class="form-text"
                    >
                        <div class="text-con">
                            {{ formatterCycle(detailInfo) }}
                        </div>
                    </el-form-item>
                    <el-form-item v-if="detailInfo.sellvol" label="取出金额：" class="form-text">
                        <div class="text-con">
                            {{ $util.fmtNum(detailInfo.sellvol) + "元" }}
                        </div>
                    </el-form-item>
                    <el-form-item v-if="detailInfo.bankcode" label="存入账号：" class="form-text">
                        <div class="text-con">
                            {{
                                $cache.getDict("110079", detailInfo.channelid.substr(0, 4)) +
                                "-" +
                                $cache.getDict("110080", detailInfo.bankcode).substr(-4, 4) +
                                "(" +
                                detailInfo.depositcard.substr(-6, 6) +
                                ")"
                            }}
                        </div>
                    </el-form-item>
                    <el-form-item
                        v-if="detailInfo.firstinvestdate"
                        label="首次取出日期："
                        class="form-text"
                    >
                        <div class="text-con">
                            {{ formatDate(detailInfo.firstinvestdate) }}
                        </div>
                    </el-form-item>
                    <el-form-item
                        v-if="detailInfo.nextinvestdate"
                        label="下一取出日期："
                        class="form-text"
                    >
                        <div class="text-con">
                            {{ formatDate(detailInfo.nextinvestdate) }}
                        </div>
                    </el-form-item>
                    <el-form-item v-if="detailInfo.status" label="计划状态：" class="form-text">
                        <div class="text-con">
                            {{ formatterStatus(detailInfo.status) }}
                        </div>
                    </el-form-item>
                    <el-form-item label="备注：" class="form-text">
                        <div class="text-con">
                            {{
                                formatterCycle(detailInfo) +
                                "，申请金额：" +
                                $util.fmtNum(detailInfo.sellvol) +
                                "元"
                            }}
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn-contain padding-b-20">
                <button class="confirm-btn active-btn" v-on:click="infoDialogClose">返回</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";

export default {
    name: "MoneyInList",
    mixins: [mixin],
    data() {
        return {
            fund: {},
            fundcode: "",
            tranInfoVisible: false,
            infoVisible: false,
            opIndex: 2,
            curPage: 1,
            allPage: 0,
            pageSize: this.$util.getConfig().const.PAGE_SIZE
                ? this.$util.getConfig().const.PAGE_SIZE
                : 10,
            gfund: [],
            pageFund: [],
            detailInfo: {},
            tradepwd: "",
            opType: "",
            opAction: ""
        };
    },
    mounted() {
        this.queryXjbFundInfo();
    },
    methods: {
        // 查询现金宝信息
        async queryXjbFundInfo() {
            if (sessionStorage.getItem("xjbFundInfo")) {
                this.fund = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
                this.getPlanList(this.fund.fundcode);
            } else {
                const res = await fundApi.cfgFundrealtimeQueryAll();
                this.fundcode = res.data && res.data[0] && res.data[0].fundcode;
                if (!this.fundcode) {
                    this.$message({
                        type: "warning",
                        message: "未配置现金宝信息！"
                    });
                    return false;
                }
                const fundRes = await fundApi.getFundLists({
                    fundcode: this.fundcode,
                    pagesize: 10,
                    pagenum: 1
                });
                if (fundRes.data) {
                    this.fund = fundRes.data.list[0];
                    sessionStorage.setItem("xjbFundInfo", JSON.stringify(this.fund));
                }
                this.getPlanList(this.fundcode);
            }
        },
        moneyOutShowFn() {
            if (!this.fund.fundcode) {
                this.$message({
                    type: "warning",
                    message: "未配置现金宝信息！"
                });
                return false;
            }
            // 获取现金宝买基金适当性信息
            this.$util.fundRiskCheck(this, this.fund, (res) => {
                this.$router.push({
                    name: "autoextractor",
                    query: { activeIndex: "2" }
                });
            });
        },
        dialogClose() {
            this.opIndex = 2;
            this.tradepwd = "";
            this.tranInfoVisible = false;
        },
        infoDialogClose() {
            this.infoVisible = false;
        },
        async nextFn() {
            const params = {};
            params.action = this.opAction;
            params.planno = this.detailInfo.planno;
            params.transactionaccountid = this.detailInfo.transactionaccountid;
            params.tradepassword = this.$util.enc(this.tradepwd);
            const res = await fundApi.planOperation(params);
            if (res.data) {
                this.opIndex = 3;
                this.getPlanList(this.fundcode);
            }
        },
        formatterBankCode(row, column, value) {
            return (
                this.$cache.getDict("110079", row.channelid.substr(0, 4)) +
                "-" +
                this.$cache.getDict("110080", row.bankcode).substr(-4, 4) +
                "(" +
                row.depositcard.substr(-4, 4) +
                ")"
            );
        },
        formatterCycle(row, column, value) {
            if (!row.investcycle || !row.investcyclevalue) {
                return "";
            }
            const cyclestr =
                (row.investcycle == "2" ? "每" : "") +
                this.$cache.getDict("110009", row.investcycle); // 0-每月，1-每周，2-双周，3-每日
            let valuestr;
            if (row.investcycle == "0") {
                valuestr = row.investcyclevalue + "日";
            } else if (row.investcycle == "3") {
                valuestr = "";
            } else {
                valuestr = "星期" + this.$util.numsDayToText(row.investcyclevalue);
            }
            return cyclestr + (this.$util.isEmpty(valuestr) ? "" : valuestr);
        },
        formatterStatus(value) {
            if (value == "N") {
                return "正常";
            } else if (value == "P") {
                return "暂停";
            } else {
                return "终止";
            }
        },
        formatterNum(row, column, value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatDate(dateNumber) {
            return (
                dateNumber.substr(0, 4) +
                "年" +
                dateNumber.substr(4, 2) +
                "月" +
                dateNumber.substr(-2, 2) +
                "日"
            );
        },
        handleCurrentChange() {
            this.allPage = this.gfund.length;
            let i = 0;
            this.pageFund = [];
            for (i; i < this.pageSize; i++) {
                if (this.gfund[(this.curPage - 1) * this.pageSize + i]) {
                    this.pageFund.push(this.gfund[(this.curPage - 1) * this.pageSize + i]);
                } else {
                    return;
                }
            }
        },
        // 获取资产信息
        async getPlanList(fundcode) {
            const res = await fundApi.getPlan({ fundcode: fundcode, planflag: 5 });
            if (res.data) {
                this.gfund = res.data.data || [];
                this.gfund = this.planArrGroup(this.gfund);
                this.getNewFund();
                this.handleCurrentChange();
            }
        },
        // 对定投协议进行排序，列表第一排列顺序为状态，参与中>已暂停>已终止；列表第二排列顺序为定投成功期数，以期数最多倒序排列；
        planArrGroup(planArr) {
            const successFund = [];
            const stopFund = [];
            const terminationFund = [];
            planArr.forEach((item) => {
                if (item.saveplanmode == "1") {
                    if (item.status == "N") {
                        successFund.push(item);
                    } else if (item.status == "P") {
                        stopFund.push(item);
                    } else {
                        terminationFund.push(item);
                    }
                }
            });
            return [
                ...this.planArrSort(successFund),
                ...this.planArrSort(stopFund),
                ...this.planArrSort(terminationFund)
            ];
        },
        planArrSort(planArr) {
            if (planArr.length == 0) {
                return [];
            }
            const planObject = {};
            planArr.forEach((item) => {
                let key = item.investcycle + "-" + item.investcyclevalue;
                if (!planObject[key]) {
                    // 如果该key不存在于结果对象中，则初始化一个新的数组
                    planObject[key] = [];
                    // 将当前项添加到对应的数组中
                    planObject[key].push(item);
                } else {
                    planObject[key].push(item);
                }
            });
            const planArrSort = [];
            Object.values(planObject).forEach((item) => {
                planArrSort.push(item);
            });
            planArrSort.sort((a, b) => b.length - a.length);
            return [].concat(...planArrSort);
        },
        // 获取基金可用操作
        getNewFund() {
            const acctStatus = this.$cache.getUser().status;
            this.gfund.forEach((item) => {
                let btnArr = "";
                const status = item.status;
                // 普通定投
                if (status === "N") {
                    if (acctStatus === "7") {
                        btnArr = "p,e";
                    } else {
                        btnArr = "c,p,e";
                    }
                } else if (status === "P") {
                    if (acctStatus === "7") {
                        btnArr = "e";
                    } else {
                        btnArr = "c,s,e";
                    }
                }
                item.statusText = btnArr;
            });
        },
        showMoreInfo(fundInfo) {
            this.detailInfo = fundInfo;
            this.infoVisible = true;
        },
        btnAction(val, fundInfo) {
            this.$util.fundRiskCheck(this, fundInfo, (res) => {
                if (val == "c") {
                    this.$router.push({
                        name: "autoextractor",
                        query: {
                            activeIndex: "2",
                            planno: fundInfo.planno,
                            fundcode: fundInfo.fundcode,
                            sellvol: fundInfo.sellvol,
                            investcycle: fundInfo.investcycle,
                            investcyclevalue: fundInfo.investcyclevalue,
                            channelid: fundInfo.channelid,
                            transactionaccountid: fundInfo.transactionaccountid
                        }
                    });
                    return;
                }
                if (val == "s") {
                    this.opType = "恢复";
                    this.opAction = "resume";
                }
                if (val == "p") {
                    this.opType = "暂停";
                    this.opAction = "pause";
                }
                if (val == "e") {
                    this.opType = "终止";
                    this.opAction = "close";
                }
                this.detailInfo = fundInfo;
                this.tranInfoVisible = true;
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-money-in-list {
    .money-in-text {
        height: 50px;
        line-height: 50px;
        background: #f9f9f9;
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
        padding: 0px 16px;
        box-sizing: border-box;
    }
    .tab-list-tit {
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
        .auto-in-null {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .fund-status {
            padding: 3px 10px;
            font-size: 12px;
            font-weight: 500;
            text-align: center;
            border-radius: 15px;
        }
        .normal-color {
            color: #0256ff;
            background: #e8ecff;
        }
        .stop-color {
            color: #f0a10e;
            background: #ffeece;
        }
        .termination-color {
            color: #ea0000;
            background: #ffdede;
        }
        .fund-desc-btns {
            display: flex;
            justify-content: center;
            .fund-desc-btn {
                cursor: pointer;
                color: var(--color-primary);
                font-size: 14px;
                font-weight: normal;
                padding: 0 10px;
            }
            .bar {
                margin-top: 3px;
                height: 16px;
                width: 1px;
                background-color: #e8e8e8;
            }
        }
    }
    .add-plan-content {
        padding: 20px 0;
        cursor: pointer;
        .add-plan-btn {
            width: 248px;
            height: 50px;
            border-radius: 30px;
            background: #f9f9f9;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            .add-icon {
                padding: 4px 8px;
                background: var(--color-primary);
                border: none;
                border-radius: 50%;
                color: #ffffff;
                margin-right: 6px;
            }
        }
        .add-plan-btn:hover {
            color: #ffffff;
            background-color: var(--color-primary);
            .add-icon {
                border: 1px solid #ffffff;
            }
            .add-text {
                color: #ffffff;
                background-color: var(--color-primary);
            }
        }
    }
    .tran-info-dialog {
        .info-dialog-header {
            display: flex;
            margin-top: 24.18px;
            .position-absolute1 {
                position: absolute;
                left: 95px;
                .header-img-text1 {
                    position: absolute;
                    top: 6px;
                    left: 45px;
                }
            }
            .position-absolute2 {
                position: absolute;
                left: 256.8px;
                .header-img-text2 {
                    position: absolute;
                    top: 6px;
                    left: 45px;
                }
            }
            .position-absolute3 {
                position: absolute;
                left: 418.6px;
                .header-img-text3 {
                    position: absolute;
                    top: 6px;
                    left: 45px;
                }
            }
        }
        .tran-info-form {
            margin-left: 25px;
            margin-bottom: 20px;
            .form-text {
                color: #666666;
            }
            .text-con {
                font-size: 18px;
                font-weight: normal;
                color: #333333;
            }
            :deep(.el-form-item__label) {
                padding: 0 !important;
                font-size: 18px;
                font-weight: normal;
            }
        }
        .btn-contain {
            text-align: center;
            .cancel-btn {
                margin-right: 40px;
                width: 180px;
                text-align: center;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e4e4e4;
                border: none;
                font-size: 16px;
                font-weight: 500;
                color: #666666;
                cursor: pointer;
            }
            .confirm-btn {
                width: 180px;
                text-align: center;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                border: none;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
            }
            .active-btn {
                background: var(--color-primary);
                cursor: pointer;
            }
            .disable-btn {
                background: #f7b2b8;
            }
        }
        .successs-img-text {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 640px;
            height: 242px;
            border-radius: 6px;
            background: #f9f9f9;
            box-sizing: border-box;
            padding-top: 40px;
            margin-bottom: 30px;
            .successs-text {
                margin-top: 23.83px;
                font-size: 26px;
                font-weight: 500;
                color: #333333;
            }
        }
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
    .display-flex {
        display: flex;
    }
    .margin-r-4 {
        margin-right: 4px;
    }
    .margin-t-50 {
        margin-top: 50px;
    }
    .padding-t-20 {
        padding-top: 20px;
    }
    .padding-b-20 {
        padding-bottom: 20px;
    }
    .color-f006671 {
        color: #f06671;
    }
    .pagination-content {
        text-align: end;
        padding: 0 20px;
    }
    :deep(.el-input) {
        width: 200px;
        margin-right: 10px;
    }
}
</style>
